"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.identifyWithSpringboard = exports.softIdentify = exports.submitEmailValidateRequest = exports.autoIdentifyOnLoadKey = exports.SubmitErrors = void 0;
var axios_1 = __importDefault(require("axios"));
var SubmitErrors;
(function (SubmitErrors) {
    SubmitErrors["NoAccess"] = "Your email has not been granted access to this page";
    SubmitErrors["Server"] = "Something went wrong, please try again later.";
    SubmitErrors["EmailEmpty"] = "Please enter your email to access the page";
    SubmitErrors["NameEmpty"] = "Please enter your name to access the page";
    SubmitErrors["EmailInvalid"] = "Please enter a valid email address";
})(SubmitErrors = exports.SubmitErrors || (exports.SubmitErrors = {}));
exports.autoIdentifyOnLoadKey = "ACCESS_AUTH_AUTO_IDENTIFY_ON_LOAD";
var submitEmailValidateRequest = function (_a) {
    var submitUrl = _a.submitUrl, email = _a.email, name = _a.name;
    return __awaiter(void 0, void 0, Promise, function () {
        var error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post(submitUrl, {
                            type: "EmailConfirmation",
                            email: email,
                            profileData: {
                                username: name,
                                email: email,
                            },
                        }, { withCredentials: true })];
                case 1:
                    _d.sent();
                    return [2, { ok: true }];
                case 2:
                    error_1 = _d.sent();
                    if (((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 401 || ((_c = error_1.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
                        return [2, { ok: false, error: SubmitErrors.NoAccess }];
                    }
                    return [2, { ok: false, error: SubmitErrors.Server }];
                case 3: return [2];
            }
        });
    });
};
exports.submitEmailValidateRequest = submitEmailValidateRequest;
var softIdentify = function (_a) {
    var submitUrl = _a.submitUrl, email = _a.email, name = _a.name;
    return __awaiter(void 0, void 0, Promise, function () {
        var result, error_2;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post(submitUrl, {
                            type: "SoftConfirmation",
                            email: email,
                            profileData: {
                                username: name,
                                email: email,
                            },
                        }, { withCredentials: true })];
                case 1:
                    result = _d.sent();
                    return [2, { ok: true, redirectUrl: result.data.redirectUrl }];
                case 2:
                    error_2 = _d.sent();
                    if (((_b = error_2.response) === null || _b === void 0 ? void 0 : _b.status) === 401 || ((_c = error_2.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
                        return [2, { ok: false, error: SubmitErrors.NoAccess }];
                    }
                    return [2, { ok: false, error: SubmitErrors.Server }];
                case 3: return [2];
            }
        });
    });
};
exports.softIdentify = softIdentify;
var identifyWithSpringboard = function (_a) {
    var submitUrl = _a.submitUrl, clerkToken = _a.clerkToken;
    return __awaiter(void 0, void 0, Promise, function () {
        var result, error_3;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.post(submitUrl, {
                            type: "SpringboardConfirmation",
                        }, {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(clerkToken),
                            },
                        })];
                case 1:
                    result = _d.sent();
                    return [2, { ok: true, redirectUrl: result.data.redirectUrl }];
                case 2:
                    error_3 = _d.sent();
                    if (((_b = error_3.response) === null || _b === void 0 ? void 0 : _b.status) === 401 || ((_c = error_3.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
                        return [2, { ok: false, error: SubmitErrors.NoAccess }];
                    }
                    return [2, { ok: false, error: SubmitErrors.Server }];
                case 3: return [2];
            }
        });
    });
};
exports.identifyWithSpringboard = identifyWithSpringboard;
